import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import { financeServicesSelector } from "../../../../../utils/financeUtils";
import { getServicesListSelector } from "../../../../../utils/externalPriceUtils";
import UscBasketItemWrapper from "../common/UscBasketItemWrapper";
import Text from "../../../styles/atoms/Text";

const BasketServices = (): JSX.Element => {
    const financeServices = useUscSelector(financeServicesSelector, shallowEqual);
    const services = useUscSelector(getServicesListSelector("included"), shallowEqual);
    const titleLabel = useUscLabel("uscBasketServicesTitle");

    const servicesLength = financeServices.length + services.length;

    return (
        <div data-testid="usc-basketservices">
            {!!servicesLength && (
                <UscBasketItemWrapper title={titleLabel}>
                    {services.map((service) => (
                        <li key={service.label}>
                            <Text variant="body-small-book">{service.label}</Text>
                            <Text variant="body-small-book" color="grey-7">
                                {service.formattedPrice}
                            </Text>
                        </li>
                    ))}
                    {financeServices.map((financeService) => (
                        <li key={financeService.key}>
                            <Text variant="body-small-book">{financeService.label}</Text>
                            <Text variant="body-small-book">
                                <span dangerouslySetInnerHTML={{ __html: financeService.formattedPrice }} />
                            </Text>
                        </li>
                    ))}
                </UscBasketItemWrapper>
            )}
        </div>
    );
};

export default BasketServices;
